// Mapa de dependencias entre campos
const fieldDependencies = {
    queQuieresEstudiar: {
        grado: {
            showFields: ['tipoEstudioContainer'],
            tipoEstudio: ['Presencial', 'Online'],
            areaConocimiento: ['Tecnología', 'Diseño', 'Negocios']
        },
        master: {
            showFields: ['tipoEstudioContainer', 'areaConocimientoContainer'],
            tipoEstudio: ['Presencial', 'Online', 'Executive'],
            areaConocimiento: ['Tecnología', 'Diseño', 'Negocios']
        },
        ciclo: {
            showFields: ['areaConocimientoContainer'],
            areaConocimiento: ['Tecnología', 'Diseño']
        }
    }
};

document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('complexCourseForm');
    const studySelect = document.getElementById('courseFormStudy');
    const studyTypeSelect = document.getElementById('courseFormStudyType');
    const knowledgeAreaSelect = document.getElementById('courseFormKnowledgeArea');

    // Verifica que los elementos existan
    if (!studySelect || !studyTypeSelect || !knowledgeAreaSelect) {
        //console.error('Uno o más elementos no se encontraron en el DOM.');
        return;
    }

    studySelect.addEventListener('change', updateDependentFields);

    function updateDependentFields() {
        const selectedStudy = studySelect.value;
        const dependentFields = fieldDependencies[selectedStudy];

        // Ocultar todos los campos dependientes
        document.getElementById('tipoEstudioContainer').style.display = 'none';
        document.getElementById('areaConocimientoContainer').style.display = 'none';

        if (dependentFields) {
            // Mostrar campos dependientes según la selección
            dependentFields.showFields.forEach(fieldId => {
                const field = document.getElementById(fieldId);
                if (field) {
                    field.style.display = 'block';
                }
            });

            // Actualizar opciones de Tipo de Estudio
            if (dependentFields.tipoEstudio) {
                updateSelectOptions(studyTypeSelect, dependentFields.tipoEstudio);
            }

            // Actualizar opciones de Área de Conocimiento
            if (dependentFields.areaConocimiento) {
                updateSelectOptions(knowledgeAreaSelect, dependentFields.areaConocimiento);
            }
        }
    }

    function updateSelectOptions(selectElement, options) {
        selectElement.innerHTML = '<option value="" selected disabled>Selecciona...</option>';
        options.forEach(option => {
            const optionElement = document.createElement('option');
            optionElement.value = option.toLowerCase().replace(/\s+/g, '_');
            optionElement.textContent = option;
            selectElement.appendChild(optionElement);
        });
    }
});
